import { render, staticRenderFns } from "./BrickDelaySettings.vue?vue&type=template&id=1eb35328&"
import script from "./BrickDelaySettings.vue?vue&type=script&lang=js&"
export * from "./BrickDelaySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb35328')) {
      api.createRecord('1eb35328', component.options)
    } else {
      api.reload('1eb35328', component.options)
    }
    module.hot.accept("./BrickDelaySettings.vue?vue&type=template&id=1eb35328&", function () {
      api.rerender('1eb35328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickDelaySettings.vue"
export default component.exports